import React from "react";
import { NavLink } from "react-router-dom";
import { LINKTYPE, BUTTONSTYLE, OVERLAY } from "@constants";
import classnames from "classnames";
import * as icons from "@assets/js/icons";
import useHeaderStore from "@store/header";
import {useVideoType,useVideoId} from "@store/video";
import path from "@assets/js/browser-path";

import isTrue from "@assets/js/is-true";

import "./nav-button.scss";

const NavButton = ({ fields, clickHandler }) => {
  
  const setMenuOverlayActive = useHeaderStore((state) => state.setMenuOverlayActive);
  const [,setVideoType] = useVideoType();
  const [,setVideoId] = useVideoId();

  const link = fields?.link || null;
  const linkType = link?.value?.linktype?.toUpperCase() || LINKTYPE.EXTERNAL;
  
  let style = fields?.style?.value ? fields?.style?.value?.toUpperCase() : '';

  const text = link?.value?.text || fields?.title?.value;
  const href = link?.value?.href;
  const url = link?.value?.url;
  const title = link?.value?.title;

  const hasArrow = isTrue(fields?.hasArrow);
  const isInverted = isTrue(fields?.isInverted);
  const Icon = link?.value?.icon ? icons[fields?.link.value.icon] : null;

  const ArrowSmallSvg = icons["ArrowSmallSvg"];

  const classList = classnames({
    "nav-button": true,
    "is-outlined": style === BUTTONSTYLE.GHOST,
    "is-link": style === BUTTONSTYLE.LINK,
    "is-small": style === BUTTONSTYLE.SMALL,
    "is-inverted": isInverted,
  });


  const overlay = fields?.command;
  const overlayExists = Object.values(OVERLAY).includes(overlay?.value.toUpperCase());


  const getTextFragment = () => {
    if (text) return <span className="text">{text}</span>;
    return <></>;
  };

  const getIconFragment = () => {
    if (Icon) {
      return <span className="icon">
        <Icon />
      </span>;
    }
    return <></>;
  };

  const getArrowFragment = () => {
    if (hasArrow) {
      return <span className="icon">
        <ArrowSmallSvg />
      </span>
    }
    return <></>;
  };

  const openOverlayHandler = () => {
    setMenuOverlayActive(overlay.value.toUpperCase());
  };

  const onClickHandler = () => {
    if (clickHandler) {
      let url = href;
      if(url && !url.startsWith('http'))
        url = path.join(process.env.REACT_APP_ROOTAPI, url);

      clickHandler(text, url)
    }
  }

  const getLinkFragment = () => {
    if ( overlay && overlayExists ) {
      return <button className={classList} onClick={openOverlayHandler}>
        {getTextFragment()}
        {getIconFragment()}
        {getArrowFragment()}
      </button>;
    }
    else if (link) {        
      switch (linkType) {
        case LINKTYPE.INTERNAL: 
        case LINKTYPE.EXTERNAL:
        case LINKTYPE.MAILTO:
          return <a className={classList} href={href} title={title} aria-current="page" target={fields.link?.value?.target} onClick={onClickHandler}>
            {getTextFragment()}
            {getIconFragment()}
            {getArrowFragment()}
          </a>
        case LINKTYPE.JAVASCRIPT:
          return <a href={url} className={classList}>
            {getTextFragment()}
            {getIconFragment()}
            {getArrowFragment()}
          </a>
        default:
          return <></>
      };
    }
  }

  
  return (
    <>
      {fields?.videoType?.value && fields?.videoId?.value ? <>
        <a className={classList} href={link?.value?.href || "#"} onClick={event=>{
          event.stopPropagation();
          event.preventDefault();
          
          setVideoType(fields.videoType.value);
          setVideoId(fields.videoId.value);
        }}>
          {getTextFragment()}
          {getIconFragment()}
          {getArrowFragment()}
        </a>
      </> 
      : 
      <>
        {getLinkFragment() }
      </>}
    </>
  );
};

export default NavButton;

export const ghostState = {
  fields: {
    hasArrow: {
      value: true,
    },
    isInverted: {
      value: false,
    },
    style: {
      value: "ghost",
    },
    link: {
      value: {
        href: "",
        text: "",
        linktype: "external",
      },
    },
  },
};
